export default __webpack_public_path__ + "static/forbes-star-2b4e52af14b674ca2a8c3a286df98d68.svg";